import { useLocation } from 'react-router-dom';

/**
 * Where to land after sign-in / sign-up.
 *
 * RequireAuth stashes the blocked destination in `?next=`, which is how a
 * "Save to Grove" click from a public share link survives the login detour.
 * Only in-app paths are honoured — an absolute URL here would be an open
 * redirect, and `//host` is a protocol-relative URL wearing a path costume.
 */
export function nextPathFrom(search: string, fallback = '/queue'): string {
  const raw = new URLSearchParams(search).get('next');
  if (!raw) return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//')) return fallback;
  return raw;
}

export function useNextPath(fallback = '/queue'): string {
  return nextPathFrom(useLocation().search, fallback);
}

/** Appends the current `next` to a sibling auth link so it isn't lost. */
export function withNext(path: string, search: string): string {
  const raw = new URLSearchParams(search).get('next');
  return raw ? `${path}?next=${encodeURIComponent(raw)}` : path;
}
